import React from 'react'
export default class SeudoSelect extends React.Component {
    click (e) {
        this.props.selected(e.target.id, e.target.innerHTML)
    }
    render () {
        let elements = null
        
        elements  = this.props.data.map((data)=>{
           if (!data) return null
            return <div onClick={this.click.bind(this)} id={data._id} key={`${Math.random()}aa`}>{data[this.props.field]}</div>
        })
        if(!this.props.data.length || this.props.data.length <= 0){
            elements =  null
        }
        let renderBool = this.props.data.length <= 0 ? false: true;
        return (
            <div className="seudoContainer">
                {renderBool? (
                    <div className="selectOptions">
                        {elements}
                    </div>
                ): null}
            </div>
            
            
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Health/SeudoSelect.js